export default __webpack_public_path__ + "static/media/Believer's Straps of the Purple Sun.d921275c.jpg";